import { StyledPullToRefresh } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { EventrLogo } from '../../assets/svgImages/Logo'
import { bs, useBoundStore } from '../../state/bound.store'
import { useRouteGuardContext } from '../../state/routeGuardProvider'
import AddEmptyItinerarySplash from '../team/AddEmptyItinerarySplash'
import { ButtonsAndArrowsDisplayedHome } from './homeButtonsAndArrows'

export const NoItinerariesInstrunctionsHome = () => {
    const { noItineraries } = useBoundStore(
        useShallow((s) => {
            return { noItineraries: s.noItineraries }
        })
    )
    const { isAllowed } = useRouteGuardContext()

    return (
        <>
            <Stack width={'100%'} padding={'0px 8px 10%'}>
                <EventrLogo />
            </Stack>

            <StyledPullToRefresh
                onRefresh={async () => {
                    /// Nothing
                }}
                promiseFunction={async () => {
                    await bs().fetchUsers()
                    await bs().getProfile()
                    await bs().forceItineraryMapUpdate()
                    await bs().fetchOrgConfig()
                }}
                maxPullDownDistance={100}
            >
                <AddEmptyItinerarySplash />
            </StyledPullToRefresh>
            {!noItineraries && <ButtonsAndArrowsDisplayedHome />}
            {!isAllowed(['allowedEdit']) && <ButtonsAndArrowsDisplayedHome />}
        </>
    )
}
